import { styled } from '@mui/material/styles';
import TableCell from '@mui/material/TableCell';

export const KwTableCell = styled(TableCell)<{ selected?: boolean }>`
  padding: 18px;
`;
